<ng-container *ngIf="useLottieAnimation; else defaultLoader">
	<lottie-animation
		[path]="lottiePath"
		[staticFrame]="false"
		[loop]="true"
		[autoplay]="true"
	></lottie-animation>
</ng-container>

<ng-template #defaultLoader>
	<div class="ring inside">
		<div class="row">
			<span class="cell empty"></span>
			<span class="cell filled"></span>
			<span class="cell filled"></span>
			<span class="cell empty"></span>
		</div>
		<div class="row">
			<span class="cell filled"></span>
			<span class="cell empty"></span>
			<span class="cell empty"></span>
			<span class="cell filled"></span>
		</div>
		<div class="row">
			<span class="cell filled"></span>
			<span class="cell empty"></span>
			<span class="cell empty"></span>
			<span class="cell filled"></span>
		</div>
		<div class="row">
			<span class="cell empty"></span>
			<span class="cell filled"></span>
			<span class="cell filled"></span>
			<span class="cell empty"></span>
		</div>
	</div>

	<div class="ring outside">
		<div class="row">
			<span class="cell empty"></span>
			<span class="cell empty"></span>
			<span class="cell empty"></span>
			<span class="cell empty"></span>
		</div>
		<div class="row">
			<span class="cell empty"></span>
			<span class="cell filled"></span>
			<span class="cell filled"></span>
			<span class="cell empty"></span>
		</div>
		<div class="row">
			<span class="cell empty"></span>
			<span class="cell filled"></span>
			<span class="cell filled"></span>
			<span class="cell empty"></span>
		</div>
		<div class="row">
			<span class="cell empty"></span>
			<span class="cell empty"></span>
			<span class="cell empty"></span>
			<span class="cell empty"></span>
		</div>
	</div>
</ng-template>
